import { getCardType } from "./utility";
export const trackAdobeDncPages = (
    ComponentName,
    currentAppState,
    adobeEventName,
    userDetail,
    dynamicObject = {} 
) => {
    const cardName = currentAppState?.cardListDetails?.uniqueIdentifier || "NA";
    const cardType = currentAppState?.cardListDetails?.cardType || "NA";
    const pageURL = window.location.href;
    let shortCode = userDetail?.shortCode;
    // ==================================================
    // ORACLE TRACKING
    // ==================================================
    try {
        if (ComponentName !== 'help' && ComponentName !== 'error') {
            let oracleData = {
                "product": "sprint",
                "pageName": `sbi-card:sprint:${ComponentName}`,
                "pageLink": pageURL,
                "page-url": pageURL,
                "cardName": cardName,
                "siteName": "SBI Card - sprint",
                "cardType": cardType,
                ...(shortCode && { shortCode })
            };
            // Execute Oracle tracking script safely
            (function () {
                try {
                    window.ORA = window.ORA || { productReady: [] };

                    window.ORA.productReady.push([
                        "analytics",
                        function () {
                            return window.ORA.view({ data: oracleData });
                        },
                    ]);
                } catch (oracleInitErr) {
                    console.error("Oracle Initialization Failed:", oracleInitErr);
                }
            })();
        } else {
            console.error("Oracle Initialization Failed");
        }
    } catch (oracleError) {
        console.error("Oracle Tracking Failed:", oracleError);
    }

    // ==================================================
    // ADOBE DNC TRACKING
    // ==================================================
    const setAdobeDncconfig = async () => {
        try {
            const { adobe_object } = window.global || {};
            const adobeArray = [];
            let req_fields = [];
            let pageExist = [];
            let fieldValues = [];

            if (!adobe_object?.datalayerParams) {
                console.warn("Adobe configuration not found in global object");
                return;
            }

            // Filter page configuration
            pageExist = adobe_object.datalayerParams.filter(
                (i) =>
                    i.page?.abobeInclude &&
                    i.page?.screenInfo?.componentName === ComponentName &&
                    i.page.screenInfo.adobeIncludeOnLoad
            );

            if (!pageExist.length) {
                console.warn("Adobe page config not found for:", ComponentName);
                return;
            }

            // -----------------------------------------------
            // Extract page info and form details
            // -----------------------------------------------
            adobeArray["pageName"] = pageExist[0].page?.pageInfo?.pageName;
            adobeArray["pageURL"] = pageExist[0].page?.pageInfo?.pageURL;
            adobeArray["siteIdentifier"] = pageExist[0].page?.siteIdentifier;
            adobeArray["primaryCategory"] = pageExist[0].page?.primaryCategory;
            adobeArray["platform"] = pageExist[0].page?.platform;

            let default_val;
            let apiresponseStatus = "";
            let decisionCode = "";
            let reason = "";
            let adobePageForm;

            if (
                pageExist[0].page?.isReusable &&
                Object.entries(dynamicObject).length > 0 &&
                dynamicObject.hasOwnProperty("wipStepName")
            ) {
                default_val = dynamicObject.wipStepName;
                adobePageForm = pageExist[0][default_val]?.form[0];

                if (
                    adobePageForm?.responseStatus?.abobeinclude &&
                    adobePageForm?.responseStatus?.storedValue === "default" &&
                    dynamicObject.hasOwnProperty("wipDefaultstaus")
                ) {
                    apiresponseStatus = dynamicObject.wipDefaultstaus;
                    decisionCode = dynamicObject.wipDefaultstaus;
                    reason = dynamicObject.wipDefaultstaus;
                } else {
                    decisionCode = adobePageForm?.decisionCode?.abobeinclude ?
                        adobePageForm.decisionCode.storedValue :
                        "";
                }
            } else {
                default_val = "default";
                adobePageForm = pageExist[0][default_val]?.form[0];
                decisionCode = adobePageForm?.decisionCode?.abobeinclude ?
                    adobePageForm.decisionCode.storedValue :
                    "";
            }

            adobeArray["subCategory2"] = adobePageForm?.subCategory2 || "";
            adobeArray["formStepName"] =
                adobePageForm?.formStepNameabobeinclude && adobePageForm?.formStepName ?
                    adobePageForm.formStepName :
                    "";
            adobeArray["formName"] = adobePageForm?.formName || "";
            adobeArray["milestone"] =
                adobePageForm?.haveMilestoneadobe && adobePageForm?.mileStoneName ?
                    adobePageForm.mileStoneName :
                    "";
            adobeArray["status"] = adobePageForm?.responseStatus?.abobeinclude ?
                adobePageForm.responseStatus.storedValue :
                apiresponseStatus;
            adobeArray["decisionCode"] = decisionCode;
            adobeArray["reason"] = adobePageForm?.reason?.abobeinclude ?
                adobePageForm.reason.storedValue :
                reason;

            // ---------------- Collect Field Values ----------------
            if (adobePageForm?.formFieldAbobeinclude) {
                req_fields = adobePageForm.fields.filter((j) => j.abobeinclude);
            }

            if (req_fields.length) {
                req_fields.forEach((ele, i) => {
                    const fieldName = req_fields[i]?.fieldName;
                    const elementName = req_fields[i]?.elementName;
                    const fieldType = req_fields[i]?.fieldType;
                    try {
                        if (fieldType === "store" && eval(elementName)) {
                            fieldValues[i] = `${fieldName}:${eval(elementName)}`;
                        }
                    } catch (e) {
                        console.warn(`Field evaluation failed for ${elementName}`, e);
                    }
                });

                fieldValues = fieldValues.join("|");
            }

            // Event mapping
            const event = pageExist[0].event?.filter(
                (e) => e.abobeInclude && e.adobeEventName === adobeEventName
            );
            adobeArray["event"] = event[0]?.adobeEventName;

            if (window.adobeDataLayer) {
                adobeDataLayerScript(adobeArray, currentAppState, userDetail, fieldValues);
            } else {
                console.warn("adobeDataLayer not found");
            }
        } catch (adobeError) {
            console.error("Adobe Tracking Failed:", adobeError);
        }
    };

    // Delay Adobe to give Oracle priority
    setTimeout(() => {
        setAdobeDncconfig();
    }, 300);
};

const getAbobeObject = (adobeArray, currentAppState, userDetail, fieldValues) => {

    let cardType = getCardType(currentAppState?.cardListDetails?.cardType, userDetail?.cardType);
    let cardName = currentAppState?.cardListDetails?.uniqueIdentifier && currentAppState?.cardListDetails?.uniqueIdentifier !== undefined ? currentAppState.cardListDetails.uniqueIdentifier : "";
    const gemId1 = localStorage.getItem("gemId1");
    const gemId2 = localStorage.getItem("gemId2");
    const shortcode = localStorage.getItem("cShortCode"); // campaign short code
    const leadsourceCode = userDetail?.shortCode;
    const pageName = adobeArray["siteIdentifier"] + ":" + adobeArray["primaryCategory"] + ":" + cardName + ":" + adobeArray["subCategory2"] + ":" + adobeArray['pageName']
    let newobj = {};
    const pageURL = window.location.href;
    let pageViewObj = {
        "event": adobeArray['event'],
        "page": {
            "pageInfo": {
                "pageName": pageName,
                "pageURL": pageURL,
            },
            "category": {
                "primaryCategory": adobeArray["primaryCategory"],
                "subCategory1": cardName,
                "subCategory2": adobeArray["subCategory2"],
                "platform": adobeArray["platform"],
            },
        },
        "card": {
            "cardName": cardName,
            "cardType": cardType,
            "channel": "SAPL" //userdetail not accessible on page load
        },
        "campaign": {
            "gemID1": gemId1 !== "null" ? gemId1 : "",
            "gemID2": gemId2 !== "null" ? gemId2 : "",
            "csCode": shortcode !== "null" ? shortcode : "", //campaign short code
        }
    }
    if (adobeArray['event'] === 'pageView') {
        newobj = {
            ...pageViewObj,
            "form": {
                "formName": adobeArray["formName"],
                "formStepName": adobeArray["formStepName"]
            }
        }
    } else if (adobeArray["event"] === 'formStart') {
        newobj = {
            ...pageViewObj,
            "mileStoneEvent": adobeArray["milestone"],
            "form": {
                "formName": adobeArray["formName"],
                "formStepName": adobeArray["formStepName"]
            },
            "CTAClick": {
                "CTAName": "",
                "CTAType": "", // button, link, image
                "CTAPosition": "", // header, body, footer, navigation panel
            }
        }
    } else if (adobeArray["event"] === 'formStep') {
        newobj = {
            ...pageViewObj,
            "mileStoneEvent": adobeArray["milestone"],
            "form": {
                "formName": adobeArray["formName"],
                "formStepName": adobeArray["formStepName"],
                "leadID": leadsourceCode,
                "formFields": fieldValues, //Pass only if applicable
                "status": adobeArray["status"], //blank
                "decisionCode": adobeArray["decisionCode"],
                "reason": adobeArray["reason"]
            }
        }
    } else if (adobeArray["event"] === 'errorPage') {
        var siteError = adobeArray["status"] + ":" + adobeArray["reason"] + "|" + fieldValues; //Pass this field only if applicable //blank
        pageViewObj["page"]["category"]["siteError"] = siteError;
        newobj = {
            ...pageViewObj,
            "form": {
                "formName": adobeArray["formName"],
                "formStepName": adobeArray["formStepName"],
                "leadID": leadsourceCode,
            }
        }
    }

    return newobj;
};
export const adobeDataLayerScript = (adobeArray, currentAppState, userDetail, fieldValues) => {
    let adobeObject = getAbobeObject(adobeArray, currentAppState, userDetail, fieldValues);
    if (window.adobeDataLayer)
        window.adobeDataLayer.push(adobeObject);

};

export const getAbobeObjectCTAClick = (userDetail, currentAppState, fieldObj, from_page, sd1_page_name) => {
    const cardName = currentAppState?.cardListDetails?.uniqueIdentifier;
    const cardType = currentAppState?.cardListDetails?.cardType;
    const gemId1 = localStorage.getItem("gemId1");
    const gemId2 = localStorage.getItem("gemId2");
    const shortcode = localStorage.getItem("cShortCode");// campaign short code
    let formFields = "";
    let pageName = "";
    let CTAName = "";
    let milestoneName = "";
    let formStepName = "";
    let subCategory2 = "";
    if (from_page === "SD2") {
        formFields = `City:${fieldObj?.city}|State:${fieldObj?.state}`
        pageName = `sbi-card:SPRINT application:${cardName}:KYC digilocker:Digilocker Residential Address`;
        CTAName = "Confirm";
        milestoneName = "SoftDecision2Submit";
        formStepName = "Digilocker Residential Address";
        subCategory2 = "KYC digilocker";
    }
    else if (from_page === "SD1") {
        var formStepName_val;
        if (sd1_page_name === "Occupation Details")
            formStepName_val = "Occupation Details";
        else
            formStepName_val = "Workplace Address";
        const companyCategory = `${userDetail.companyCategory}`;
        if (companyCategory === "")
            formFields = `City:${userDetail.resiCity}|Occupation Type:${userDetail.occupation}`;
        else
            formFields = `City:${userDetail.resiCity}|Occupation Type:${userDetail.occupation}|Company Category:${userDetail.companyCategory}`;
        pageName = `sbi-card:SPRINT application:${cardName}:Professional Details:${sd1_page_name}`;
        CTAName = "Continue to step 3";
        milestoneName = "SoftDecision1Submit";
        formStepName = formStepName_val;
        subCategory2 = "Professional Details";
    }
    const pageURL = window.location.href;
    let clickObj = {
        "event": "CTAClick",
        "page": {
            "pageInfo": {
                "pageName": pageName,
                "pageURL": pageURL,
            },
            "category": {
                "primaryCategory": "SPRINT application", // pass “sprint application”
                "subCategory1": cardName, // Pass Card Name
                "subCategory2": subCategory2,// Pass section of the form journey
                "platform": "web"
            },
        },

        "CTAClick": {
            "CTAName": CTAName,
            "CTAType": "button", // button, link, image
            "CTAPosition": "body", // header, body, footer, navigation panel
        },

        "card": {
            "cardName": cardName,
            "cardType": cardType,
            "channel": "SAPL"
        },
        "campaign": {
            "gemID1": gemId1 !== "null" ? gemId1 : "",
            "gemID2": gemId2 !== "null" ? gemId2 : "",
            "csCode": shortcode !== "null" ? shortcode : "", //campaign short code
        },

        "mileStoneEvent": milestoneName,//Pass only if applicable

        "form": {
            "formName": "SPRINT Application Form",
            "formStepName": formStepName,
            "leadID": userDetail?.shortCode,
            "formFields": formFields, //Pass only if applicable
            "photoMatchPerc": "", //Pass this field only if applicable
            "status": from_page, //Pass this field only if applicable
            "decisionCode": "",
            "reason": "" //Pass this field only if applicable
        }
    }
    if (window.adobeDataLayer)
        window.adobeDataLayer.push(clickObj);
};

// Map form pages to labels and analytics data
const getPageMeta = (pageName, ctaName) => {
    const map = {
        SD1: {
            CTAName: "SD1 Submit",
            pageName: "sbi-card:sprint:office-address",
            formStep: "Workplace Address",
        },
        SD2: {
            CTAName: "Start Apply Journey",
            pageName: "sbi-card:sprint:personal-details",
            formStep: "Start Apply Journey",
        },
        SD3: {
            CTAName: "Continue",
            pageName: "sbi-card:sprint:personal-details",
            formStep: "Personal Details",
        },
        SD4: {
            CTAName: "SSL Submit",
            pageName: "sbi-card:sprint:OTP-confirmation",
            formStep: "OTP Confirmation",
        },
        SD5: {
            CTAName: "Confirm City",
            pageName: "sbi-card:sprint:city",
            formStep: "City",
        },
        SD6: {
            CTAName: "Confirm",
            pageName: "sbi-card:sprint:pAN-and-dOB",
            formStep: "PAN and DOB",
        },
        SD7: {
            CTAName: "Continue to Step 2",
            pageName: "sbi-card:sprint:contact-referral",
            formStep: "Contact and Referral",
        },
        SD8: {
            CTAName: "Confirm & Continue",
            pageName: "sbi-card:sprint:professional-details",
            formStep: "Professional Details",
        },
        SD9: {
            CTAName: "SD1 Submit",
            pageName: "sbi-card:sprint:office-address",
            formStep: "Office Address",
        },
        SD10: {
            CTAName: "Manaul address update",
            pageName: "sbi-card:sprint:residential-address",
            formStep: "Residential Address",

        },
        SD11: {
            CTAName: "Downsell submit",
            pageName: "sbi-card:sprint:Downsell",
            formStep: "Downsell Page",
        },
        SD12: {
            CTAName: "Continue",
            pageName: "sbi-card:sprint:video-KYC-verification",
            formStep: "Video KYC Verification",
        },
        SD14: {
            CTAName: "Confirm OTP",
            pageName: "sbi-card:sprint:OTP-Confirmation",
            formStep: "OTP Confirmation",
        },
        SD16: {
            CTAName: "Continue for instant KYC",
            pageName: "sbi-card:sprint:digilocker-instant-KYC",
            formStep: "Digilocker for instant KYC",
        },
        SD17: {
            CTAName: "Okay",
            pageName: "sbi-card:sprint:final-submission",
            formStep: "Final Submission",
        },
        SD18: {
            CTAName: "Continue",
            pageName: "sbi-card:sprint:network-preference",
            formStep: "Network Preference Popup",
        },
        SD19: {
            CTAName: "Photo Completion",
            pageName: "sbi-card:sprint:take-photo",
            formStep: "Take Photo",
        },
        SD20: {
            CTAName: "SD2 Submit - Address change case ",
            pageName: "sbi-card:sprint:gender-view",
            formStep: "Gender Screen",
        },
        SD22: {
            CTAName: "Selection of AA",
            pageName: "sbi-card:sprint:AA-selection",
            formStep: "AA Selection Page",
        },
        SD23: {
            CTAName: "Telco Submit",
            pageName: "sbi-card:sprint:telco",
            formStep: "Telco Screen",
        },
        SD24: {
            CTAName: "MITC completed",
            pageName: "sbi-card:sprint:MITC",
            formStep: "MITC Page",
        }
    };


    return (
        map[ctaName] || {
            CTAName: ctaName,
            pageName: `sbi-card:sprint:${pageName || "unknown"}`,
            formStep: "Generic Step",
        }
    );
};

// tracking function
export const getOracleCTAClick = (
    page_Name,
    currentAppState = {},
    ctaName,
    shortCode = ""
) => {
    try {
        const pageURL = window?.location?.href || "";
        const cardName = currentAppState?.cardListDetails?.uniqueIdentifier || "NA";
        const cardType = currentAppState?.cardListDetails?.cardType || "NA";
        // Get mapped page info
        const { CTAName, pageName, formStep } = getPageMeta(page_Name, ctaName);

        // ---------------------------------
        // 🔹 Oracle Tracking
        // ---------------------------------
        const oracleData = {
            product: "sprint",
            pageName,
            pageLink: pageURL,
            "page-url": pageURL,
            cardName,
            cardType,
            formStep,
            siteName: "SBI Card - sprint",
            linkName: CTAName,
            ...(shortCode && { shortCode })
        };

        try {
            window.ORA = window.ORA || { productReady: [] };
            if (typeof window.ORA.click === "function") {
                window.ORA.click({ data: oracleData });
            } else {
                window.ORA.productReady.push([
                    "analytics",
                    () => window.ORA.click({ data: oracleData }),
                ]);
            }
        } catch (err) {
            console.error("Oracle Tracking Failed:", err);
        }
        return { oracleData };
    } catch (err) {
        console.error("Tracking Function Error:", err);
    }
};
